import type { ReactNode } from "react";
import Workspaces from "~/components/blocks/Header/NavItems/Workspaces";
import FindLocation from "~/components/blocks/Header/NavItems/FindLocation";
import Partners from "~/components/blocks/Header/NavItems/Partners";
import Resources from "~/components/blocks/Header/NavItems/Resources";

export type NavigationItem = {
  label: string;
  hasDropdown: boolean;
  url: string;
  content: ReactNode;
  onClick?: () => void;
};

export const getNavigationItems = (
  options: {
    onSpeakToFlexpert?: () => void;
    onOpenAddListing?: () => void;
    onFindNavigate?: () => void;
    findSearchUrl?: string;
  } = {},
): NavigationItem[] => {
  return [
    {
      label: "Find Space",
      hasDropdown: true,
      url: "/office-space",
      content: <Workspaces searchUrl={options.findSearchUrl} />,
      onClick: options.onFindNavigate,
    },
    {
      label: "Find a Location",
      hasDropdown: true,
      url: "/office-space",
      content: <FindLocation onEnquire={options.onSpeakToFlexpert} />,
      onClick: options.onFindNavigate,
    },
    {
      label: "Partners",
      hasDropdown: true,
      url: "/workspaces",
      content: <Partners onOpenAddListing={options.onOpenAddListing} />,
    },
    {
      label: "Resources",
      hasDropdown: true,
      url: "/blog",
      content: <Resources />,
    },
  ];
};
